export default __webpack_public_path__ + "assets/smoke-particles.af6a507c.svg";